<!-- begin::Scroll Top -->
<div
    class="m-scroll-top m-scroll-top--skin-top"
    data-toggle="m-scroll-top"
    data-scroll-offset="500"
    data-scroll-speed="300"
    appunwraptag="">
    <i class="la la-arrow-up"></i>
</div>
<!-- end::Scroll Top -->
